import createAPI from '../axios'

// 计划审核相关API
const teachingPlanImplementation = {
	teachingPlanImplementation: {
	    list: config => createAPI('/teachingPlanImplementation/list', 'post', config),
        initOption: config => createAPI('/teachingPlanImplementation/initOption', 'post', config),
        deptOption: config => createAPI('/teachingPlanImplementation/deptOption', 'post', config),
        majorOption: config => createAPI('/teachingPlanImplementation/majorOption', 'post', config),
        classOption: config => createAPI('/teachingPlanImplementation/classOption', 'post', config),
        kkjhlist: config => createAPI('/teachingPlanImplementation/kkjhlist', 'post', config),
		queryAuditAuth: config => createAPI('/teachingPlanImplementation/queryAuditAuth', 'post', config),
        updateAuditState: config => createAPI('/teachingPlanImplementation/updateAuditState', 'post', config),
        teachingPlanExport: config => createAPI('/teachingPlanImplementation/teachingPlanExport', 'post', config),
        courseInfoExport: config => createAPI('/teachingPlanImplementation/courseInfoExport', 'post', config),
	}
};

export default teachingPlanImplementation;



// WEBPACK FOOTER //
// ./src/api/modules/teachingPlanImplementation.js